import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import style from "../partnerProfileModal.module.scss";
import Loading from "../../../../shared/Loading/Loading";
import { Expeditor } from "../../../../../services";

const HistoryTab = ({ partnerId }) => {
  const { t } = useTranslation();

  const [partnerHistory, setPartnerHistory] = useState([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);

  useEffect(() => {
    if (partnerId) {
      fetchPartnerHistory(partnerId);
    }
  }, [partnerId]);

  const fetchPartnerHistory = (partnerId) => {
    if (partnerId) {
      setIsHistoryLoading(true);
      Expeditor.getPartnerHistories(partnerId)
        .then((response) => {
          setPartnerHistory(response.data);
          setIsHistoryLoading(false);
        })
        .catch((error) => {
          console.error("Error loading partner history:", error);
          setPartnerHistory([]);
          setIsHistoryLoading(false);
        });
    } else {
      setPartnerHistory([]);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("ru-RU", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className={style.history}>
      <div className={style.historyTitle}>
        <h3>{t("partnerProfile.history.title")}</h3>
      </div>

      {isHistoryLoading ? (
        <Loading inBlock marginBottom={0} />
      ) : partnerHistory && partnerHistory.length > 0 ? (
        <div className={style.historyTimeline}>
          {partnerHistory
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .map((historyItem, index) => (
              <div key={historyItem.id || index} className={style.historyItem}>
                <div className={style.historyDot}></div>
                <div className={style.historyContent}>
                  <div className={style.historyEventTitle}>{historyItem.action}</div>
                  <div className={style.historyEventDetails}>
                    <span className={style.historyDate}>{formatDate(historyItem.createdAt)}</span>
                    <span className={style.historyDivider}>•</span>
                    <span className={style.historyAuthor}>{historyItem.author}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <div className={style.noDocuments}>
          <span>{t("partnerProfile.history.noHistory")}</span>
        </div>
      )}
    </div>
  );
};

export default HistoryTab;
